export function upperCaseFirstLetter(input: string) {
	return String(input).charAt(0).toUpperCase() + String(input).slice(1);
}

export function shorten(input: string, length: number) {
	if (input.length <= length) return input;
	return input.slice(0, length) + '...';
}
